import React, { FC } from 'react'
import { format, toPriceNoCurrency } from '@dt/fe-utils'
import './index.scss'

import flowerImg from '@img/mkt/giftcard/flower.png'
import flowerBorImg from '@img/mkt/giftcard/flower-border.png'
import flowerShaImg from '@img/mkt/giftcard/flower-shadow.png'
import archedImg from '@img/mkt/giftcard/arched.png'
import archedBorImg from '@img/mkt/giftcard/arched-border.png'
import archedShaImg from '@img/mkt/giftcard/arched-shadow.png'
import rectangleImg from '@img/mkt/giftcard/rectangle.png'
import rectangleBorImg from '@img/mkt/giftcard/rectangle-border.png'
import rectangleShaImg from '@img/mkt/giftcard/rectangle-shadow.png'
import squareImg from '@img/mkt/giftcard/square.png'
import squareBorImg from '@img/mkt/giftcard/square-border.png'
import squareShaImg from '@img/mkt/giftcard/square-shadow.png'

interface IProps {
  scene?: string;
  cardFace: string;
  balance?: number;
  cardName?: string;
  shape?: 'flower' | 'arched' | 'rectangle' | 'square' | string;
  border?: 'none' | 'border' | 'shadow';
  isScale?: boolean;
}

const CardShape: FC<IProps> = (props: IProps) => {
  const { scene, cardName, balance, cardFace, border = 'none', shape = 'rectangle', isScale = true } = props
  const shapeMap = {
    flower: {
      img: flowerImg,
      border: flowerBorImg,
      shadow: flowerShaImg
    },
    arched: {
      img: archedImg,
      border: archedBorImg,
      shadow: archedShaImg
    },
    rectangle: {
      img: rectangleImg,
      border: rectangleBorImg,
      shadow: rectangleShaImg
    },
    square: {
      img: squareImg,
      border: squareBorImg,
      shadow: squareShaImg
    }
  }
  const isMyCardsScene = scene === 'myCards'
  return (
    <div
      className={`mkt-gift-card-shape${border === 'shadow'
        ? (isMyCardsScene ? ' my-add-shadow-padding' : ' add-shadow-padding')
        : ''}`}
      style={isScale && shape === 'rectangle' ? { height: '67%', transform: 'translateY(24%)' } : {}}
    >
      {isMyCardsScene && (
        <>
          <div className='my-gift-card-border'></div>
          <div className='card-brief-info'>
            <div className='card-brief-info-name'>{cardName}</div>
            <div className='card-brief-info-price'>
              {`${i18n.t('mkt.common.balance')} ${format.toCurrency()} `}
              <span className='card-brief-info-price-num'>{toPriceNoCurrency(balance)}</span>
            </div>
          </div>
        </>
      )}
      {/* <div className={`gift-card-shape-img ${shape}`} style={{ transform: `scale(${border === 'shadow' ? 0.92 : 0.95})`, backgroundImage: `url(${cardFace})` }}></div> */}
      <img
        style={{
          maskImage: `url(${shapeMap[shape].img})`,
          WebkitMaskImage: `url(${shapeMap[shape].img})`,
          ...(isMyCardsScene ? { width: `${shape === 'rectangle' ? '' : '65%'}` } : {})
        }}
        className={`gift-card-shape-img${isMyCardsScene ? ' my-gift-card-shape-img' : ''} ${shape}${border !== 'none' ? ' has-border' : ''}`}
        src={cardFace}
      />
      {!isMyCardsScene && border && border !== 'none' && <div className='gift-card-shape-border' style={{ backgroundImage: `url(${shapeMap[shape][border]})` }}></div>}
    </div>
  )
}
export default CardShape
